import { createRouter, createWebHistory } from 'vue-router'
import BaseView from "../views/BaseView.vue"
import ProvidersList from "@/views/ProvidersList.vue"
import SignIn from "@/views/SignIn.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: BaseView
  },
  {
    path: '/index',
    name: 'index',
    component: ProvidersList
  },
  {
    path: '/sign-in',
    name:'sign-in',
    component: SignIn
  },
  {
    path: '/connected',
    name: 'connected',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AccountConnected.vue')
  },
    {
      path: '/duplicate-account',
      name: 'duplicate-account',
      component: () => import(/* webpackChunkName: "about" */ '../views/DuplicateAccount.vue')  // Add the new route for duplicate account
    }
    ,
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
